import {useEffect, useState} from 'react';

const mediaQueries = [
  window.matchMedia('(max-width: 599.99px)'),
  window.matchMedia('(min-width: 600px) and (max-width: 959.99px)'),
  window.matchMedia('(min-width: 960px) and (max-width: 1279.99px)'),
  window.matchMedia('(min-width: 1280px)'),
];

const useMediaQuery = () => {
  const getScreenSize = () => ({
    isXSmall: mediaQueries[0].matches,
    isSmall: mediaQueries[1].matches,
    isMedium: mediaQueries[2].matches,
    isLarge: mediaQueries[3].matches,
  });

  const [screenSize, setScreenSize] = useState(getScreenSize);

  useEffect(() => {
    const updateScreenSize = () => setScreenSize(getScreenSize());

    mediaQueries.forEach((mq) =>
      mq.addEventListener('change', updateScreenSize),
    );

    return () =>
      mediaQueries.forEach((mq) =>
        mq.removeEventListener('change', updateScreenSize),
      );
  }, []);

  return screenSize;
};

export default useMediaQuery;
